/*
 * Hero with products — color swatches.
 * Clicking a swatch swaps the card's image to that color's variant image
 * (in place, no navigation) and marks the swatch active. Delegated from the
 * document so it covers every card and section without per-card wiring.
 */
(function () {
  function activate(swatch) {
    var card = swatch.closest('.hp-card');
    if (!card) return;

    var img = card.querySelector('.hp-card__image');
    var url = swatch.getAttribute('data-image-url');
    if (img && url) {
      img.src = url;
      img.removeAttribute('srcset'); // let the swapped src win over the responsive set
    }

    var swatches = card.querySelectorAll('.hp-card__swatch');
    for (var i = 0; i < swatches.length; i++) {
      swatches[i].classList.toggle('is-active', swatches[i] === swatch);
    }
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.hp-card__swatch');
    if (!swatch) return;
    event.preventDefault();
    activate(swatch);
  });
})();